import { PlayIcon } from "lucide-react";

import { TiktokIcon } from "@/Icons";
import { cn } from "@/lib/utils";

type TiktokThumbnailProps = {
  className?: string;
  size?: "default" | "lg";
};

export default function TiktokThumbnail({
  className,
  size = "default",
}: TiktokThumbnailProps) {
  return (
    <div
      className={cn(
        "relative flex items-start justify-end p-[8%] bg-linear-to-br from-rose-500 via-pink-500 to-fuchsia-600",
        className
      )}
    >
      <TiktokIcon className="w-1/6 h-auto text-white drop-shadow" aria-hidden />

      <PlayIcon
        className={cn(
          "absolute top-1/2 left-1/2 -translate-1/2 fill-white stroke-white drop-shadow",
          size === "lg" ? "size-16" : "size-9"
        )}
      />
    </div>
  );
}
